import React from 'react';
import authRoles from '../../../auth/authRoles';
import Room from './Room';
import Rooms from './Rooms';

const CheckInOutConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/checkinout/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Room />
				</React.Suspense>
			),
		},
		{
			path: '/checkinout',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Rooms />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default CheckInOutConfig;
